module.exports = __webpack_public_path__ + "3f22f317b5a6baf0ccfeade02cd50211.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/more.svg
// module id = 767
// module chunks = 0